// extracted by mini-css-extract-plugin
export default {"welcomeSection":"TechnikaWelcome_welcomeSection__mRw3k","title":"TechnikaWelcome_title__gQTHr","text":"TechnikaWelcome_text__afOle","textPhone":"TechnikaWelcome_textPhone__yksfR"};